import { makeStyles, Theme, createStyles, Box, BoxProps, Typography } from "@material-ui/core";
import background from "./background.jpg";
import dashboardImage from "../dashboard_image.png";

export type DashboardHeaderProps = {
  title: string;
  body: string;
} & BoxProps;

export const DashboardHeader = ({ title, body, ...props }: DashboardHeaderProps) => {
  const classes = useStyles();

  return (
    <Box {...props} className={classes.root}>
      <Box className={classes.textRoot}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.body}>{body}</Typography>
      </Box>
      <Box className={classes.imageRoot}>
        <img className={classes.image} src={dashboardImage} alt="Volt screenshot" />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      borderRadius: 4,
      boxShadow: "0 1px 1px 0 rgba(32, 37, 43, 0.12), 0 0 1px 0 rgba(32, 37, 43, 0.1)",
      backgroundColor: "rgba(83, 82, 87, 1.00)",
      backgroundImage: `url(${background})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      minHeight: "192px",
    },
    textRoot: {
      display: "flex",
      flexDirection: "column",
      padding: `${theme.spacing(5)}px ${theme.spacing(2.5)}px`,
      flexBasis: "55%",
      minWidth: "min-content",
    },
    title: {
      fontSize: 22,
      fontWeight: 600,
      lineHeight: "29px",
      color: "white",
    },
    body: {
      marginTop: theme.spacing(1.5),
      fontSize: 16,
      fontWeight: "normal",
      lineHeight: "24px",
      color: theme.palette.blueGrey.main,
    },
    imageRoot: {
      display: "flex",
      flexBasis: "45%",
      position: "relative",
    },
    image: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      maxWidth: "100%",
      maxHeight: 230,
      overflow: "visible",
      marginLeft: "auto",
      marginRight: "auto",
    },
  }),
);
